// ©2024 Austin App House. All rights reserved.
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import {
    MDBModal,
    MDBRow,
    MDBIcon,
    MDBModalBody,
    MDBCol,
    MDBInput,
    MDBBtn,
    MDBContainer,
} from 'mdbreact';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import axios from 'axios';
import { connect } from 'react-redux';
import { white as customSelectStyle } from '../../../utils/customSelectStyle';
import InputRange from '../../dashboard/inputRange';
import { toggleModal } from '../../../storage/actions/modalsActions';
import { setFiltersObject } from '../../../storage/actions/workOrdersActions';
import CustomFieldFiltersSection from '../../layout/filters/CustomFieldFiltersSection';
import CustomSelect from "../../layout/CustomSelect";
import FiltersModalShell from './FiltersModalShell';

class ModalWOFilters extends React.Component {
    constructor(props) {
        super(props);
        const filters = props.filters || {};
        this.state = {
            form: {
                selectedWorkTypes: new Set(filters.selectedWorkTypes || []),
                startDate: filters.startDate || {},
                selectedCompanies: new Set(filters.selectedCompanies || []),
                zipCode: filters.zipCode || '',
                cityName: filters.cityName || '',
                selectState: filters.selectState || '',
                selectCountry: filters.selectCountry || {
                    name: 'United States',
                    value: 'US',
                    label: 'United States',
                },
                filterByDistance: filters.filterByDistance || '',
                selectCompany: filters.selectCompany || '',
                filterByStatusOnHold: filters.filterByStatusOnHold || '',
                selectProject: filters.selectProject || '',
                workOrderId: filters.workOrderId || '',
                siteName: filters.siteName || '',
                payRate: filters.payRate || {},
                finalPay: filters.finalPay || {},
                selectedCustomFields: new Set(filters.selectedCustomFields || []),
            },
            clients: [],
            companies: [],
            projects: [],
            stateArray: [],
            countries: [],
            rateTypes: [
                {
                    value: 'Hour',
                    label: 'Hour',
                },
                {
                    value: 'Device',
                    label: 'Device',
                },
                {
                    value: 'Site',
                    label: 'Site / Flat',
                },
            ],
            customFields: [],
            workTypes: [],
        };
    }

    // eslint-disable-next-line react/sort-comp
    resetFilters = () => {
        this.setState({
            form: {
                selectedWorkTypes: new Set([]),
                startDate: {},
                selectedCompanies: new Set([]),
                zipCode: '',
                cityName: '',
                selectState: '',
                selectCountry: {
                    name: 'United States',
                    value: 'US',
                    label: 'United States',
                },
                filterByDistance: '',
                selectCompany: '',
                filterByStatusOnHold: '',
                selectProject: '',
                workOrderId: '',
                siteName: '',
                payRate: {},
                finalPay: {},
                selectedCustomFields: new Set([]),
            },
        });
    }

    handlerOnChange = ({ name, value }) => {
        this.setState(
            cur => ({ form: { ...cur.form, [name]: value || '' } }),
            () => {
                if (name === 'selectCountry') this.getStates();
            },
        );
    }

    handlerSetChanges = ({ target }) => {
        const newSet = new Set([...this.state.form[target.name]]);
        const command = target.checked ? 'add' : 'delete';
        newSet[command](target.value);
        this.setState(cur => ({ form: { ...cur.form, [target.name]: newSet } }));
    }

    handlerObjectChanges = (field, name, value) => {
        this.setState(cur => ({
            form: { ...cur.form, [field]: { ...cur.form[field], [name]: value || '' } },
        }));
    }

    closeModal = () => this.props.toggleModal(false, 'filtersModal');

    handlerAccept = event => {
        event.preventDefault();
        const filters = this.getFilters();
        this.props.getFilters(filters);
        this.closeModal();
    }

    getFilters = () => {
        const fields = Object.keys(this.state.form);
        if (!fields.length) return null;
        const result = {};
        fields
            .filter(key => (
                this.state.form[key] !== ''
                && (!(this.state.form[key] instanceof Set) || this.state.form[key].size > 0)
                && (
                    !(this.state.form[key] instanceof Object)
                    || (this.state.form[key] instanceof Set)
                    || (this.state.form[key] instanceof Date)
                    || this.state.form[key].from
                    || this.state.form[key].to
                    || this.state.form[key].value
                    || this.state.form[key].length
                )
            ))
            .forEach(key => {
                if (this.state.form[key] instanceof Set) {
                    result[key] = [...this.state.form[key]];
                    return;
                }
                if (this.state.form[key] instanceof Date) {
                    result[key] = this.state.form[key].toString();
                    return;
                }
                result[key] = this.state.form[key];
            });
        return result;
    }

    getCountries = () => {
        axios.get('/api/address/getAllCountries')
            .then(res => {
                if (res.data.length && res.data.length > 0) {
                    return this.setState({
                        countries: res.data.map(item => ({
                            ...item,
                            label: item.name,
                            value: item.isoCode,
                        })),
                    }, this.getStates);
                }
                throw new Error('Can\'t get list of countries!');
            })
            .catch(error => {
                console.error(error);
            });
    }

    getStates = () => {
        axios.get('/api/address/getStatesOfCountry', {
            params: { countryId: this.state?.form?.selectCountry?.value || '' },
        })
            .then(res => {
                this.setState({
                    stateArray: res.data?.payload?.states || [],
                });
            })
            .catch(error => {
                console.error(error);
            });
    }

    getWorkTypes = () => {
        axios.get('/api/users/getTools')
            .then(res => {
                if (res.data.Tools && res.data.Tools.length > 0) {
                    return this.setState({ workTypes: res.data.Tools });
                }
                throw new Error('Can\'t get list of work types!');
            })
            .catch(error => {
                console.error(error);
            });
    }

    getInfoFromPreviouslyWork = () => {
        axios.get('/api/contractor/fetch_fields_by_previously_work')
            .then(res => {
                if (!res.data.success) throw new Error('Can\'t get list of projects!');
                this.setState({
                    projects: res.data.projects,
                    companies: res.data.companies,
                    customFields: res.data.customFields,
                    clients: res.data.clients,
                });
            })
            .catch(error => {
                console.error(error);
            });
    }

    componentDidMount() {
        this.getCountries();
        this.getWorkTypes();
        this.getInfoFromPreviouslyWork();
    }

    render() {
        const { isOpen } = this.props;
        const {
            companies,
            projects,
            stateArray,
            countries,
            rateTypes,
            customFields,
            workTypes,
            clients,
        } = this.state;
        const {
            selectedWorkTypes,
            startDate,
            selectedCompanies,
            zipCode, cityName, selectState, selectCountry,
            filterByDistance,
            selectCompany,
            filterByStatusOnHold,
            selectProject,
            workOrderId, siteName,
            payRate, finalPay,
            selectedCustomFields,
        } = this.state.form;
        const currentFilters = this.getFilters() || {};
        const activeFiltersCount = Object.keys(currentFilters).length;

        return (
            <FiltersModalShell
                title={`Filter (${activeFiltersCount})`}
                onClose={this.closeModal}
                footer={(
                    <>
                        <button
                            type="button"
                            className="dashboard-btn dashboard-btn--secondary"
                            onClick={this.resetFilters}
                        >
                            Reset Filters
                        </button>
                        <button
                            type="button"
                            className="dashboard-btn dashboard-btn--primary"
                            onClick={this.handlerAccept}
                        >
                            Accept
                        </button>
                    </>
                )}
            >
                        <div className="field_row">
                            <div className="field_name">
                                Miles
                            </div>
                            <div>
                                <InputRange
                                    defaultValue={filterByDistance || NaN}
                                    handler={value => this.handlerOnChange({ name: 'filterByDistance', value: value || '' })}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Start Date
                            </div>
                            <div className="field_block">
                                <DatePicker
                                    name="startDateFrom"
                                    selected={startDate.from}
                                    onChange={date => this.handlerObjectChanges('startDate', 'from', date)}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="From"
                                />
                            </div>
                            <div style={{position: "relative", top:"10px"}}>-</div>
                            <div className="field_block">
                                <DatePicker
                                    name="startDateTo"
                                    selected={startDate.to}
                                    onChange={date => this.handlerObjectChanges('startDate', 'to', date)}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="To"
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Company
                            </div>
                            <div className="field_block">
                                <CustomSelect
                                    isClearable
                                    isSearchable
                                    options={companies}
                                    value={selectCompany}
                                    styles={customSelectStyle}
                                    onChange={value => this.handlerOnChange({ name: 'selectCompany', value })}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Project
                            </div>
                            <div className="field_block">
                                <CustomSelect
                                    isClearable
                                    isSearchable
                                    options={projects}
                                    value={selectProject}
                                    styles={customSelectStyle}
                                    onChange={value => this.handlerOnChange({ name: 'selectProject', value })}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Company WO ID
                            </div>
                            <div className="field_block">
                                <input
                                    type="text"
                                    name="workOrderId"
                                    className="input-field"
                                    placeholder="Type Company WO ID"
                                    value={workOrderId}
                                    onChange={event => this.handlerOnChange(event.target)}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                City
                            </div>
                            <div className="field_block">
                                <input
                                    type="text"
                                    name="cityName"
                                    className="input-field"
                                    placeholder="Type city name"
                                    value={cityName}
                                    onChange={event => this.handlerOnChange(event.target)}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                State
                            </div>
                            <div className="field_block">
                                <CustomSelect
                                    isClearable
                                    isSearchable
                                    options={stateArray}
                                    value={selectState}
                                    styles={customSelectStyle}
                                    onChange={value => this.handlerOnChange({ name: 'selectState', value })}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Zip
                            </div>
                            <div className="field_block">
                                <input
                                    type="text"
                                    name="zipCode"
                                    className="input-field"
                                    placeholder="Type zip code"
                                    value={zipCode}
                                    onChange={event => this.handlerOnChange(event.target)}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Country
                            </div>
                            <div className="field_block">
                                <CustomSelect
                                    options={countries}
                                    value={selectCountry}
                                    styles={customSelectStyle}
                                    onChange={value => this.handlerOnChange({ name: 'selectCountry', value })}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Site Name
                            </div>
                            <div className="field_block">
                                <input
                                    type="text"
                                    name="siteName"
                                    className="input-field"
                                    placeholder="Type site name"
                                    value={siteName}
                                    onChange={event => this.handlerOnChange(event.target)}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Base Pay
                            </div>
                            <div className="field_block">
                                <input
                                    type="text"
                                    name="payRateFrom"
                                    placeholder="From"
                                    value={payRate.from}
                                    onChange={event => this.handlerObjectChanges('payRate', 'from', parseFloat(event.target.value) || 0)}
                                />
                            </div>
                            <div style={{position: "relative", top:"10px"}}>-</div>

                            <div className="field_block">
                                <input
                                    type="text"
                                    name="payRateTo"
                                    placeholder="To"
                                    value={payRate.to}
                                    onChange={event => this.handlerObjectChanges('payRate', 'to', parseFloat(event.target.value) || 0)}
                                />
                            </div>

                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Base pay per
                            </div>
                            <div className="field_block">
                                <CustomSelect
                                    isClearable
                                    options={rateTypes}
                                    value={payRate.type}
                                    styles={customSelectStyle}
                                    onChange={value => this.handlerObjectChanges('payRate', 'type', value)}
                                />
                            </div>
                            </div>
                        <div className="field_row">
                            <div className="field_name">
                                Final Pay
                            </div>
                            <div className="field_block">
                                <input
                                    type="text"
                                    name="finalPayFrom"
                                    className="input-field width-inherit"
                                    placeholder="From"
                                    value={finalPay.from}
                                    onChange={event => this.handlerObjectChanges('finalPay', 'from', parseFloat(event.target.value) || 0)}
                                />
                            </div>
                            <div style={{position: "relative", top:"10px"}}>-</div>
                            <div className="field_block">
                                <input
                                    type="text"
                                    name="finalPayTo"
                                    className="input-field width-inherit"
                                    placeholder="To"
                                    value={finalPay.to}
                                    onChange={event => this.handlerObjectChanges('finalPay', 'to', parseFloat(event.target.value) || 0)}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                                <div className="field_name">
                                    Final pay per
                                </div>
                                <div className="field_block">
                                    <CustomSelect
                                        isClearable
                                        options={rateTypes}
                                        value={finalPay.type}
                                        styles={customSelectStyle}
                                        onChange={value => this.handlerObjectChanges('finalPay', 'type', value)}
                                    />
                                </div>
                            </div>
                        <CustomFieldFiltersSection
                            customFields={customFields}
                            selectCustomField={value => this.handlerOnChange({ name: 'selectedCustomFields', value: new Set(value || []) })}
                            selectedCustomFields={[...selectedCustomFields]}
                        />
                        <div className="field_row">
                            <div className="field_name">
                                On Hold
                            </div>
                            <div className="field_block checkbox_group">
                                <label key={filterByStatusOnHold} className="check_btn">{filterByStatusOnHold ? 'On Hold' : 'All'}
                                <input
                                    key="filterByStatusOnHold"
                                    className="float-right"
                                    type="checkbox"
                                    id="filterByStatusOnHold"
                                    value={filterByStatusOnHold}
                                    name="filterByStatusOnHold"
                                    checked={filterByStatusOnHold}
                                    onChange={() => this.handlerOnChange({ name: 'filterByStatusOnHold', value: !filterByStatusOnHold })}
                                />
                                <span>{filterByStatusOnHold}</span>
                                </label>
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Clients Previously worked for
                            </div>
                            <div className="field_block">
                                <CustomSelect
                                    isClearable
                                    isSearchable
                                    isMulti
                                    closeMenuOnSelect={false}
                                    options={clients}
                                    value={[...selectedCompanies]}
                                    styles={customSelectStyle}
                                    onChange={value => this.handlerOnChange({ name: 'selectedCompanies', value: new Set(value || []) })}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="field_name">
                                Type(s) of work
                            </div>
                            <div className="field_block checkbox_group">
                                {
                                    workTypes && workTypes.map(workType => (
                                        <label key={workType} className="check_btn">
                                        <input
                                            key={workType}
                                            className="float-right"
                                            type="checkbox"
                                            id={workType}
                                            value={workType}
                                            name="selectedWorkTypes"
                                            checked={selectedWorkTypes.has(workType)}
                                            onChange={this.handlerSetChanges}
                                        />
                                            <span>{workType}</span>
                                        </label>
                                    ))
                                }
                            </div>
                        </div>
            </FiltersModalShell>
        );
    }
}

const mapDispatchToProps = {
    toggleModal,
    getFilters: setFiltersObject,
};

const mapStateToProps = state => ({
    isOpen: state.modalState?.filtersModal?.isOpen,
    filters: state?.workOrder?.filters,
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalWOFilters);
